import React from 'react'
import { Link } from 'gatsby';
import '../style/ShowcaseSlider.scss'
import orangebox from '../images/orangebox.png'
import '../style/main.scss'
import { Transition } from 'react-transition-group';

class ShowcaseSlider extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            posts : [],
            timer: null
        };
    }

	componentDidMount () {
        this.setState({
        i: 0
        });
        const timer = setInterval( () => {
            if(this.state.i == 2){
                let x = 0;
                this.setState({i:x});
            }else{
                let x = this.state.i + 1;
                this.setState({i:x});
            }
        }, 6000);
 
        this.setState({ timer: timer })
 
    }

    handleClick(i){
        this.setState({i:i});
        this.resetInterval()
    }

    resetInterval = () => {
        
        clearInterval(this.state.timer);

        const timer = setInterval( () => {
            if(this.state.i == 2){
                let x = 0;
                this.setState({i:x});
            }else{
                let x = this.state.i + 1;
                this.setState({i:x});
            }
        }, 6000);
        
        this.setState({
            timer: timer,
        });
    }


  
    render () {
        let slide;
        if(this.state.i === 0){
            slide = (<>
                <div className="slide-container">
                    <img src={orangebox} alt="orange box" className="orange-box"/>
                    <p>WELCOME</p>
                    <h1 className=" zero fade-in teko text-white main-title">
                        REACH YOUR <br/>
                        FITNESS GOALS
                    </h1>
                    <Link to="/get_started"className="primary-button px-5">LEARN MORE</Link>
                </div>
                </>)
        }
        else if(this.state.i === 1){
            slide = (<>
                <div className="slide-container">    
                    <img src={orangebox} alt="orange box" className="orange-box box2"/>
                    <p className="title2">PERSONALIZED</p>
                    <h1 className=" zero fade-in teko text-white main-title">
                        1-ON-1 TRAINING <br/>
                        REACH YOUR GOALS FAST
                    </h1>
                    <Link to="/training"className="primary-button px-5">LEARN MORE</Link>
                </div>
                </>)
        }
        else if(this.state.i === 2){
            slide = (<>
                <div className="slide-container">
                    <img src={orangebox} alt="orange box" className="orange-box box3"/>
                    <p className="title3">SCHEDULE</p>
                    <h1 className=" zero fade-in teko text-white main-title">
                        CHECK OUT OUR<br/>
                        CLASS SCHEDULE
                    </h1>
                    <Link to="/schedule"className="primary-button px-5">LEARN MORE</Link>
                </div>
                    
                </>)
        }

        
        
    return (
        <>
        <div className="showcase_title">
        {slide}
        </div>
        <ul className="slider-buttons">
            <li onClick={() => this.handleClick(0)}>
                <div className={"line"+ (this.state.i === 0 ? " active-line":"")} ></div>
                <p>01</p>
            </li>
            <li onClick={() => this.handleClick(1)}>
                <div  className={"line"+ (this.state.i === 1 ? " active-line":"")}></div>
                <p>02</p>
            </li>
            <li onClick={() => this.handleClick(2)}>
                <div  className={"line"+ (this.state.i === 2 ? " active-line":"")}></div>
                <p>03</p>
            </li>
        </ul>
        </>
    );
   }
};
export default ShowcaseSlider;